import { render, staticRenderFns } from "./NewRegistration.vue?vue&type=template&id=6a3a559a&scoped=true&"
import script from "./NewRegistration.vue?vue&type=script&lang=js&"
export * from "./NewRegistration.vue?vue&type=script&lang=js&"
import style0 from "./NewRegistration.vue?vue&type=style&index=0&id=6a3a559a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3a559a",
  null
  
)

export default component.exports